import {Component, Input, OnInit} from '@angular/core';
import {BrowseConfig} from "@core/bean/browse-config";
import {Pagination} from "@core/bean/pagination";
import {HttpParams, HttpResponse} from "@angular/common/http";
import {CommonsService} from "@core/service/commons.service";
import {NzModalService} from "ng-zorro-antd";
import {Observable} from "rxjs";
import {SourceItemsService} from "../../../../routes/jy-srm/inquiry-parity/source-items/source-items.service";

@Component({
  selector: 'app-sourcing-browse',
  templateUrl: './sourcing-browse.component.html',
  styles: []
})
export class SourcingBrowseComponent implements OnInit {

  static componentName = 'SourcingBrowseComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;


  visible = false;
  formLoading = false;
  pagination: Pagination = new Pagination();
  searchData: any = {};
  httpResponse: HttpResponse<any>;
  titleName: any ="";

  constructor(private commonsService: CommonsService,
              private modalService: NzModalService,
              private sourcingItemsService: SourceItemsService) {
    this.pagination.getData = function(params: HttpParams): Observable<any> {
      return sourcingItemsService.getAllSourcingNo(params);
    };
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    if(this.searchData.sourcingClass==='BID'){
      this.titleName="招投标列表";
    }
    if(this.searchData.sourcingClass==='INQUIRY'){
      this.titleName="询比价列表";
    }

    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    //this.pagination.addDefaultSort(new Sort('createdDate', Direction.DESC));
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }

}
